<script>
require('@/css/style.css')

export default {
  props: ['id', 'x1', 'y1', 'x2', 'y2', 'highlight', 'selector'],
  data () {
    return {
      edgeWidth: 10,
      strokeWidth: 1,
      strokeColor: '#AAAAAA',
      opacityValue: 1,
      zIndex: 0
    }
  },
  created () {
    this.renderEdges()
  },
  watch: {
    highlight: function (val) {
      this.renderEdges()
    },
    selector: {
      handler: function (val) {
        this.renderEdges()
      },
      deep: true
    }
  },
  methods: {
    renderEdges () {
      // console.log('======= RENDER Edges =======')
      if (this.x1 === this.x2) {
        this.zIndex = 1
      }
      this.strokeWidth = 1
      this.strokeColor = '#AAAAAA'
      this.opacityValue = 1
      if (this.highlight && this.selector.group === 'nodes') {
        this.strokeWidth = 5
        this.strokeColor = '#33bbff'
        this.opacityValue = 0.7
      } else if (this.highlight && this.selector.group === 'edges') {
        this.strokeWidth = 5
        this.strokeColor = '#191970'
        this.opacityValue = 0.7
      }
    },
    clickEdge () {
      this.$emit('clickEdge', this.id)
    },
    setPolyLinePos () {
      if (this.x1 === this.x2) {
        return String(this.edgeWidth / 2) + ',0' + ' ' + String(this.edgeWidth / 2) + ',' + String(this.y2 - this.y1)
      } else if (this.x1 < this.x2) {
        return String(this.edgeWidth / 2) + ',0' + ' ' + String(this.edgeWidth / 2) + ',' + String((this.y2 - this.y1) / 2) + ' ' + String(this.x2 - this.x1) + ',' + String((this.y2 - this.y1) / 2) + ' ' + String(this.x2 - this.x1) + ',' + String(this.y2 - this.y1)
      } else {
        // console.log(this.edgeWidth)
        // console.log(this.x1)
        // console.log(this.x2)
        return String((this.edgeWidth / 2) + this.x1 - this.x2) + ',0' + ' ' + String((this.edgeWidth / 2) + this.x1 - this.x2) + ',' + String((this.y2 - this.y1) / 2) + ' ' + String(this.edgeWidth / 2) + ',' + String((this.y2 - this.y1) / 2) + ' ' + String(this.edgeWidth / 2) + ',' + String(this.y2 - this.y1)
      }
    }
  }
}
</script>
<style scoped>
.edge {
  position:absolute;
}
.line {
  transition: all 0.3s ease 0s;
}
.line:hover {
  stroke-width: 6;
  stroke-opacity: 1;
}
</style>
<template>
<div class="edge" :style="{left:(x1<x2 ? x1: x2) - edgeWidth/2 + 'px', top:y1 + 'px', width:(x1<x2 ? x2 - x1 : x1 - x2) + edgeWidth + 'px', height: y2 - y1 + 'px', 'z-index':zIndex}">
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
    <polyline class="line" :points="setPolyLinePos()" :stroke="strokeColor" :stroke-width="strokeWidth" :stroke-opacity="opacityValue" stroke-linecap="round" marker-start="url(#maerker1)" fill="none" />
    <polyline class="line" @click="clickEdge()" :points="setPolyLinePos()" :stroke="strokeColor" :stroke-width="edgeWidth" stroke-opacity="0" stroke-linecap="round" marker-start="url(#maerker1)" fill="none" />
  </svg>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/GraphEdge.vue